import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import user from '@/pages/user'
import login from '@/pages/login'
import notfound from '@/pages/404'
import preview from '@/pages/preview'
import purchaser from '@/pages/purchaser/index'
import supplier from '@/pages/supplier/index'
import tenderDetails from '@/pages/tenderDetails/index'
import messageNotification from '@/pages/messageNotification/index'
import messageNotificationDetails from '@/pages/messageNotificationDetails/index'
import messageNotificationEn from '@/pages/messageNotificationEn/index'
import helpCenter from '@/pages/helpCenter'
import helpDetails from '@/pages/helpDetails'
import personalCenter from '@/pages/personalCenter'
import personalCenterEn from '@/pages/personalCenterEn'
import complain from '@/pages/complain'
import inforPerfection from '@/pages/inforPerfection'
import notification from '@/pages/notification'
import notificationDetails from '@/pages/notificationDetails'
import protocol from '@/pages/protocol'
import recruitmentSystem from '@/pages/recruitmentSystem'
import supplyChain from '@/pages/supplyChain'
import supplierManagement from '@/pages/supplierManagement'
import creditService from '@/pages/creditService'
import register from '@/pages/register'
import registerBusinessInfo from '@/pages/registerBusinessInfo'
import registerExistBusinessInfo from '@/pages/registerExistBusinessInfo'
import registerUserInfo from '@/pages/registerUserInfo'
import registerExamine from '@/pages/registerExamine'
import registerFailed from '@/pages/registerFailed'
import registerComplete from '@/pages/registerComplete'
import findPassword from '@/pages/findPassword'
import verifyIdentity from '@/pages/findPassword/verifyIdentity'
import resetPassword from '@/pages/findPassword/resetPassword'
import passwordComplete from '@/pages/findPassword/passwordComplete'
import recruit from '@/pages/recruit'
import oaLogin from '@/pages/oaLogin'
import loginCas from '@/pages/loginCas'
// import fosunOALogin from '@/pages/dingdingLogin'
import loginError from '@/pages/loginError'
import fosunCmsLogin from '@/pages/fosunCmsLogin'
import loginEn from '@/pages/loginEn'
import callBack from '@/pages/callBack'
import consultingService from '@/pages/consultingService'
import appointment from '@/pages/appointment'
import supplierPerfection from '@/pages/supplierPerfection'
import fosunCmsLoginExt from '@/pages/fosunCmsLoginExt'
import supplierService from '@/pages/supplierService'
import serviceIndex from '@/pages/supplierService/serviceIndex'
import creditReport from '@/pages/creditReport'
import creditIndex from '@/pages/creditReport/creditIndex'
import dingWorkbench from '@/pages/dingWorkbench'
import regimeList from '@/pages/dingWorkbench/regimeList'
import dingSupplyChain from '@/pages/dingWorkbench/supplyChain'
import dingSomingSoon from '@/pages/dingWorkbench/comingSoon'
import dingOverseas from '@/pages/dingWorkbench/overseas'
import dingBiMobile from '@/pages/dingWorkbench/biMobile'
import noAccess from '@/pages/dingWorkbench/noAccess'
import myPage from '@/pages/dingWorkbench/myPage'


import workBench from '@/pages/workBench/index.vue'
import purchaseWorkBench from '@/pages/workBench/purchaseIndex.vue'
import supplierWorkBench from '@/pages/workBench/supplierIndex.vue'
import Cookies from 'js-cookie'

Vue.use(Router)

const router = new Router({
  routes: [{
    name: 'index',
    path: '/', // 主页
    component: index
  },{
    name: 'index',
    path: '/portal/enterprisecredit/index.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/bid/index.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/portal/fosun/index.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/bidinfo/40760.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/portal/helpCenter/index.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/portal/complaintGuide/index.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/portal/bidInfo/index.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/cms/mobile/index.htm', // 主页
    component: index
  },{
    name: 'index',
    path: '/portal/index', // 主页
    component: index
  }, {
    name: 'serviceIndex',
    path: '/supplierService/',
    component: serviceIndex
  }, {
    name: 'creditReport',
    path: '/creditReport2/',
    component: creditReport
  }, {
    name: 'creditIndex',
    path: '/creditReport/',
    component: creditIndex
  }, {
    name: 'preview',
    path: '/preview',
    component: preview
  }, {
    name: 'recruit',
    path: '/recruit',
    component: recruit
  }, {
    name: 'fosunCmsLoginExt',
    path: '/fosunCmsLoginExt',
    component: fosunCmsLoginExt
  }, {
    name: 'oaLogin',
    path: '/mem/oaLogin.htm',
    component: oaLogin
  }
  ,
   {
    name: 'loginCas',
    path: '/mem/loginCas.htm',
    component: loginCas
  },  {
    name: 'oaLogin',
    path: '/mem/fosunOALogin.htm',
    component: oaLogin
  }, {
    name: 'fosunCmsLogin',
    path: '/mem/fosunAppLogin.htm',
    component: fosunCmsLogin
  }, {
    name: 'fosunCmsLogin',
    path: '/mem/fosunCmsLogin.htm',
    component: fosunCmsLogin
  },{
    name: 'callBack',
    path: '/mem/callBack.htm',
    component: callBack
  },{
    name: 'loginError',
    path: '/loginError',
    component: loginError
  },{
    name: 'supplierPerfection',
    path: '/supplierPerfection',
    component: supplierPerfection
  },{
    name: 'purchaser',
    path: '/purchaser',
    component: purchaser
  },  {
    name: 'supplier',
    path: '/supplier',
    component: supplier
  }, {
    name: 'tenderDetails',
    path: '/tenderDetails',
    component: tenderDetails
  }, {
    name: 'messageNotification',
    path: '/messageNotification',
    component: messageNotification
  }, {
    name: 'messageNotificationEn',
    path: '/messageNotificationEn',
    component: messageNotificationEn
  }, {
    name: 'messageNotificationDetails',
    path: '/messageNotificationDetails',
    component: messageNotificationDetails
  }, {
    name: 'helpCenter',
    path: '/helpCenter',
    component: helpCenter
  }, {
    name: 'helpDetails',
    path: '/helpDetails',
    component: helpDetails
  }, {
    name: 'personalCenter',
    path: '/personalCenter',
    component: personalCenter
  }, {
    name: 'personalCenterEn',
    path: '/personalCenterEn',
    component: personalCenterEn
  }, {
    name: 'complain',
    path: '/complain',
    component: complain
  }, {
    name: 'inforPerfection',
    path: '/inforPerfection',
    component: inforPerfection
  }, {
    name: 'notification',
    path: '/notification',
    component: notification
  }, {
    name: 'notificationDetails',
    path: '/notificationDetails',
    component: notificationDetails
  }, {
    name: 'protocol',
    path: '/protocol',
    component: protocol
  }, {
    name: 'recruitmentSystem',
    path: '/recruitmentSystem',
    component: recruitmentSystem
  }, {
    name: 'supplyChain',
    path: '/supplyChain',
    component: supplyChain
  }, {
    name: 'supplierManagement',
    path: '/supplierManagement',
    component: supplierManagement
  }, {
    name: 'creditService',
    path: '/creditService',
    component: creditService
  }, {
    name: 'register',
    path: '/register',
    component: register
  }, {
    name: 'registerBusinessInfo',
    path: '/registerBusinessInfo',
    component: registerBusinessInfo
  }, {
    name: 'registerExistBusinessInfo',
    path: '/registerExistBusinessInfo',
    component: registerExistBusinessInfo
  }, {
    name: 'registerUserInfo',
    path: '/registerUserInfo',
    component: registerUserInfo
  }, {
    name: 'registerExamine',
    path: '/registerExamine',
    component: registerExamine
  }, {
    name: 'registerFailed',
    path: '/registerFailed',
    component: registerFailed
  }, {
    name: 'registerComplete',
    path: '/registerComplete',
    component: registerComplete
  }, {
    name: 'findPassword',
    path: '/findPassword',
    component: findPassword
  }, {
    name: 'verifyIdentity',
    path: '/verifyIdentity',
    component: verifyIdentity
  }, {
    name: 'resetPassword',
    path: '/resetPassword',
    component: resetPassword
  }, {
    name: 'passwordComplete',
    path: '/passwordComplete',
    component: passwordComplete
  }, {
    name: 'consultingService',
    path: '/consultingService',
    component: consultingService
  }, {
    name: 'appointment',
    path: '/appointment',
    component: appointment
  },{
    name: 'workBench',
    path: '/workBench', // 工作台中转
    component: workBench
  }, {
    name: 'purchaseWorkBench',
    path: '/purchaseWorkBench', // 采购商工作台
    component: purchaseWorkBench
  }, {
    name: 'supplierWorkBench',
    path: '/supplierWorkBench', // 供应商工作台
    component: supplierWorkBench
  }, {
    name: 'user',
    path: '/user',
    component: user
  }, {
    name: 'dingWorkbench',
    path: '/dingWorkbench',
    component: dingWorkbench
  }, {
    name: 'regimeList',
    path: '/regimeList',
    component: regimeList
  }, {
    name: 'dingSupplyChain',
    path: '/dingSupplyChain',
    component: dingSupplyChain
  }, {
    name: 'dingSomingSoon',
    path: '/dingSomingSoon',
    component: dingSomingSoon
  }, {
    name: 'noAccess',
    path: '/noAccess',
    component: noAccess
  }, {
    name: 'dingOverseas',
    path: '/dingOverseas',
    component: dingOverseas
  }, {
    name: 'dingBiMobile',
    path: '/dingBiMobile',
    component: dingBiMobile
  }, {
    name: 'myPage',
    path: '/myPage',
    component: myPage
  },
  {
    name: 'loginEn',
    path: '/loginEn',
    component: loginEn
  }, {
    name: 'login',
    path: '/login',
    component: login
  },{
    name: 'login',
    path: '/portal/mem/login.htm',
    component: login
  },{
    name: 'login',
    path: '/mem/login.htm',
    component: login
  }, {
    path: '*',
    component: notfound
  }],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: '/'
})

router.beforeEach((to, from, next) => {
  let uesrTag = Cookies.get("userTag")
  if (to && to.path === "/workBench") {
    // 10供应商  20采购商
    if (uesrTag == 20) {
      router.push({ path:'/purchaseWorkBench'});
      next();
    } else if (uesrTag == 10) {
      router.push({ path:'/supplierWorkBench'});
    } else {
      router.push({path:'/login'});
      next();
    }
  } else {
    next();
  }
});


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js